
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "app-produto-movimentacoes",
  components: { VueSelect },
  data() {
    const dataFinal = this.dataLocal(new Date());
    const inicio = new Date();
    inicio.setDate(inicio.getDate() - 29);

    return {
      resumo: null,
      carregandoResumo: false,
      carregandoMovimentacoes: false,
      metricaClientes: "faturamento",
      filtros: {
        data_inicial: this.dataLocal(inicio),
        data_final: dataFinal,
        agrupamento: "auto",
      },
      filtrosMovimentacao: {
        busca: "",
        origens: [],
        per_page: 25,
      },
      movimentacoes: [],
      paginacao: {
        current_page: 1,
        per_page: 25,
        total: 0,
      },
      opcoesAgrupamento: [
        { value: "auto", text: "Automático" },
        { value: "dia", text: "Por dia" },
        { value: "semana", text: "Por semana" },
        { value: "mes", text: "Por mês" },
      ],
      opcoesMetricaClientes: [
        { value: "faturamento", text: "Faturamento" },
        { value: "quantidade", text: "Quantidade" },
      ],
      camposMovimentacoes: [
        { key: "data", label: "Data" },
        { key: "origem_descricao", label: "Movimentação" },
        { key: "tipo", label: "Tipo" },
        { key: "quantidade", label: "Quantidade", class: "text-right" },
        { key: "saldo", label: "Saldo", class: "text-right" },
        { key: "pessoa", label: "Cliente/Fornecedor" },
        { key: "documento", label: "Documento" },
        { key: "valor_total", label: "Valor", class: "text-right" },
        { key: "detalhes", label: "Detalhes" },
      ],
      camposLotes: [
        { key: "numero", label: "Lote" },
        { key: "status", label: "Situação" },
        { key: "fabricacao", label: "Fabricação" },
        { key: "validade", label: "Validade" },
        { key: "quantidade", label: "Estoque", class: "text-right" },
        { key: "percentual_estoque", label: "% estoque", class: "text-right" },
        { key: "vendido_periodo", label: "Vendido", class: "text-right" },
        {
          key: "faturamento_periodo",
          label: "Faturamento",
          class: "text-right",
        },
        { key: "ultima_movimentacao_periodo", label: "Última movimentação" },
      ],
      camposVariacoes: [
        { key: "descricao", label: "Variação" },
        { key: "status", label: "Situação" },
        { key: "quantidade", label: "Estoque", class: "text-right" },
        { key: "percentual_estoque", label: "% estoque", class: "text-right" },
        { key: "vendido_periodo", label: "Vendido", class: "text-right" },
        {
          key: "faturamento_periodo",
          label: "Faturamento",
          class: "text-right",
        },
        { key: "ultima_movimentacao_periodo", label: "Última movimentação" },
      ],
      camposComposicao: [
        { key: "codigo", label: "Código" },
        { key: "descricao", label: "Componente" },
        { key: "quantidade", label: "Quantidade", class: "text-right" },
      ],
    };
  },
  computed: {
    produto() {
      return this.resumo?.produto || {};
    },
    indicadores() {
      return this.resumo?.indicadores || {
        hoje: {},
        ultimos_7_dias: {},
        ultimos_30_dias: {},
        total: {},
        periodo: {},
      };
    },
    clientes() {
      return this.resumo?.clientes || [];
    },
    lotes() {
      return this.resumo?.lotes || [];
    },
    variacoes() {
      return this.resumo?.variacoes || [];
    },
    resumoVariacoes() {
      return this.resumo?.resumo_variacoes || null;
    },
    resumoLotes() {
      return this.resumo?.resumo_lotes || null;
    },
    composicao() {
      return this.resumo?.composicao || [];
    },
    opcoesOrigem() {
      return this.resumo?.opcoes_origem || [];
    },
    cardsResumoVariacoes() {
      const dados = this.resumoVariacoes || {};
      const maisVendida = dados.mais_vendida_periodo;

      return [
        {
          titulo: "Combinações",
          valor: dados.total_variacoes || 0,
          legenda: `${dados.com_estoque || 0} com estoque disponível`,
          classe: "especial-primary",
        },
        {
          titulo: "Estoque nas variações",
          valor: this.formatarQuantidade(dados.quantidade_total),
          legenda: "Soma de todas as combinações",
          classe: "especial-success",
        },
        {
          titulo: "Sem estoque ou negativo",
          valor: Number(dados.sem_estoque || 0) + Number(dados.estoque_negativo || 0),
          legenda: `${dados.estoque_negativo || 0} com saldo negativo`,
          classe: "especial-danger",
        },
        {
          titulo: "Mais vendida no período",
          valor: maisVendida?.descricao || "Sem vendas",
          legenda: maisVendida
            ? `${this.formatarQuantidade(maisVendida.quantidade)} vendida(s)`
            : "Nenhuma combinação identificada",
          classe: "especial-info",
        },
      ];
    },
    cardsResumoLotes() {
      const dados = this.resumoLotes || {};
      const proximo = dados.proximo_vencimento;

      return [
        {
          titulo: "Lotes cadastrados",
          valor: dados.total_lotes || 0,
          legenda: `${dados.com_estoque || 0} com estoque disponível`,
          classe: "especial-primary",
        },
        {
          titulo: "Estoque nos lotes",
          valor: this.formatarQuantidade(dados.quantidade_total),
          legenda: "Soma de todos os lotes",
          classe: "especial-success",
        },
        {
          titulo: "Vencidos / próximos 30 dias",
          valor: `${dados.vencidos_com_estoque || 0} / ${dados.a_vencer_30_dias || 0}`,
          legenda: `${this.formatarQuantidade(dados.quantidade_vencida)} unidade(s) vencida(s)`,
          classe: "especial-danger",
        },
        {
          titulo: "Próximo vencimento",
          valor: proximo ? this.formatarData(proximo.validade) : "Sem previsão",
          legenda: proximo
            ? `Lote ${proximo.numero} · ${proximo.dias} dia(s)`
            : "Nenhum lote disponível com validade",
          classe: "especial-warning",
        },
      ];
    },
    alturaGraficoVariacoes() {
      return Math.max(280, this.variacoes.length * 42);
    },
    seriesGraficoVariacoes() {
      return [
        {
          name: "Estoque atual",
          data: this.variacoes.map((item) => Number(item.quantidade || 0)),
        },
        {
          name: "Vendido no período",
          data: this.variacoes.map((item) => Number(item.vendido_periodo || 0)),
        },
      ];
    },
    opcoesGraficoVariacoes() {
      return {
        chart: { type: "bar", toolbar: { show: false } },
        plotOptions: { bar: { horizontal: true, borderRadius: 3 } },
        colors: ["#3699ff", "#1bc5bd"],
        dataLabels: { enabled: false },
        xaxis: {
          categories: this.variacoes.map((item) => item.descricao),
          labels: { formatter: (valor) => this.formatarNumero(valor, 0) },
        },
        tooltip: {
          y: { formatter: (valor) => this.formatarQuantidade(valor) },
        },
        legend: { position: "top" },
      };
    },
    seriesGraficoLotes() {
      return [
        {
          name: "Estoque atual",
          data: this.lotes.map((item) => Number(item.quantidade || 0)),
        },
        {
          name: "Vendido no período",
          data: this.lotes.map((item) => Number(item.vendido_periodo || 0)),
        },
      ];
    },
    opcoesGraficoLotes() {
      return {
        chart: { type: "bar", toolbar: { show: false } },
        plotOptions: { bar: { borderRadius: 3, columnWidth: "48%" } },
        colors: ["#8950fc", "#1bc5bd"],
        dataLabels: { enabled: false },
        xaxis: { categories: this.lotes.map((item) => item.numero) },
        yaxis: { labels: { formatter: (valor) => this.formatarNumero(valor, 0) } },
        tooltip: {
          y: { formatter: (valor) => this.formatarQuantidade(valor) },
        },
        legend: { position: "top" },
      };
    },
    cardsVenda() {
      return [
        { chave: "hoje", titulo: "Vendido hoje", dados: this.indicadores.hoje },
        { chave: "semana", titulo: "Últimos 7 dias", dados: this.indicadores.ultimos_7_dias },
        { chave: "mes", titulo: "Últimos 30 dias", dados: this.indicadores.ultimos_30_dias },
        { chave: "total", titulo: "Desde o início", dados: this.indicadores.total },
      ];
    },
    cardsEstoque() {
      const cobertura = this.indicadores.dias_cobertura;

      return [
        {
          titulo: "Estoque atual",
          valor: this.formatarQuantidade(this.produto.quantidade),
          legenda: `Mínimo: ${this.formatarQuantidade(this.produto.estoque_minimo)}`,
          icone: "box-seam",
          classe: "bg-light-primary text-primary",
        },
        {
          titulo: "Estoque disponível",
          valor: this.formatarQuantidade(this.produto.estoque_disponivel),
          legenda: `Reservado: ${this.formatarQuantidade(this.produto.estoque_reservado)}`,
          icone: "check2-circle",
          classe: "bg-light-success text-success",
        },
        {
          titulo: "Valor em estoque",
          valor: this.formatarMoeda(this.produto.valor_estoque),
          legenda: "Calculado pelo custo atual",
          icone: "cash-stack",
          classe: "bg-light-info text-info",
        },
        {
          titulo: "Cobertura estimada",
          valor: cobertura === null ? "Sem previsão" : `${this.formatarNumero(cobertura, 1)} dias`,
          legenda: "Baseada nos últimos 30 dias",
          icone: "calendar-check",
          classe: "bg-light-warning text-warning",
        },
      ];
    },
    temVendasNoPeriodo() {
      return (this.resumo?.vendas || []).some(
        (item) => Number(item.quantidade) !== 0 || Number(item.faturamento) !== 0
      );
    },
    categoriasVendas() {
      return (this.resumo?.vendas || []).map((item) => this.formatarPeriodo(item.periodo));
    },
    seriesGraficoVendas() {
      const vendas = this.resumo?.vendas || [];
      return [
        {
          name: "Quantidade",
          type: "column",
          data: vendas.map((item) => Number(item.quantidade || 0)),
        },
        {
          name: "Faturamento",
          type: "line",
          data: vendas.map((item) => Number(item.faturamento || 0)),
        },
      ];
    },
    opcoesGraficoVendas() {
      return {
        chart: { toolbar: { show: true }, zoom: { enabled: true } },
        colors: ["#3699ff", "#1bc5bd"],
        stroke: { width: [0, 3], curve: "smooth" },
        dataLabels: { enabled: false },
        xaxis: { categories: this.categoriasVendas },
        yaxis: [
          {
            title: { text: "Quantidade" },
            labels: { formatter: (valor) => this.formatarNumero(valor, 0) },
          },
          {
            opposite: true,
            title: { text: "Faturamento" },
            labels: { formatter: (valor) => this.formatarMoedaCompacta(valor) },
          },
        ],
        tooltip: {
          shared: true,
          y: [
            { formatter: (valor) => this.formatarQuantidade(valor) },
            { formatter: (valor) => this.formatarMoeda(valor) },
          ],
        },
        legend: { position: "top" },
      };
    },
    seriesGraficoEstoque() {
      return [
        {
          name: "Saldo do estoque",
          data: (this.resumo?.estoque || []).map((item) => Number(item.saldo || 0)),
        },
      ];
    },
    conciliacaoEstoque() {
      return (this.resumo?.estoque || []).find(
        (item) => item.conciliado_estoque_atual
      );
    },
    opcoesGraficoEstoque() {
      return {
        chart: { type: "area", toolbar: { show: true }, zoom: { enabled: true } },
        colors: ["#8950fc"],
        stroke: { curve: "smooth", width: 3 },
        fill: {
          type: "gradient",
          gradient: { shadeIntensity: 1, opacityFrom: 0.35, opacityTo: 0.05 },
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories: (this.resumo?.estoque || []).map((item) =>
            this.formatarPeriodo(item.periodo)
          ),
        },
        yaxis: { labels: { formatter: (valor) => this.formatarNumero(valor, 2) } },
        tooltip: { y: { formatter: (valor) => this.formatarQuantidade(valor) } },
      };
    },
    seriesGraficoOrigens() {
      return (this.resumo?.origens || [])
        .filter((item) => Number(item.quantidade) > 0)
        .map((item) => Number(item.quantidade));
    },
    opcoesGraficoOrigens() {
      const origens = (this.resumo?.origens || []).filter(
        (item) => Number(item.quantidade) > 0
      );
      return {
        labels: origens.map((item) => item.descricao),
        legend: { position: "bottom" },
        dataLabels: { enabled: true },
        tooltip: { y: { formatter: (valor) => this.formatarQuantidade(valor) } },
        colors: ["#3699ff", "#1bc5bd", "#f64e60", "#ffa800", "#8950fc", "#6993ff"],
      };
    },
    seriesGraficoClientes() {
      return [
        {
          name: this.metricaClientes === "faturamento" ? "Faturamento" : "Quantidade",
          data: this.clientes.map((cliente) => Number(cliente[this.metricaClientes] || 0)),
        },
      ];
    },
    opcoesGraficoClientes() {
      return {
        chart: { type: "bar", toolbar: { show: false } },
        plotOptions: { bar: { horizontal: true, borderRadius: 4 } },
        colors: ["#1bc5bd"],
        dataLabels: { enabled: false },
        xaxis: {
          categories: this.clientes.map((cliente) => cliente.nome),
          labels: {
            formatter: (valor) =>
              this.metricaClientes === "faturamento"
                ? this.formatarMoedaCompacta(valor)
                : this.formatarNumero(valor, 0),
          },
        },
        tooltip: {
          y: {
            formatter: (valor) =>
              this.metricaClientes === "faturamento"
                ? this.formatarMoeda(valor)
                : this.formatarQuantidade(valor),
          },
        },
      };
    },
  },
  async mounted() {
    await this.carregarResumo();
    await this.buscarMovimentacoes(1);
  },
  methods: {
    dataLocal(data) {
      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const dia = String(data.getDate()).padStart(2, "0");
      return `${ano}-${mes}-${dia}`;
    },
    async carregarResumo() {
      this.carregandoResumo = true;
      try {
        const { data } = await this.$http.post("/produtos/analise", {
          id_produto: this.$route.params.id_produto,
          ...this.filtros,
        });
        this.resumo = data?.data || null;
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.message || "Não foi possível carregar a análise do produto."
        );
        this.$router.push({ name: "produtosLista" });
      }
      this.carregandoResumo = false;
    },
    async aplicarPeriodo() {
      if (!this.filtros.data_inicial || !this.filtros.data_final) {
        this.$toast.warning("Informe o período completo.");
        return;
      }
      if (this.filtros.data_inicial > this.filtros.data_final) {
        this.$toast.warning("A data inicial não pode ser maior que a data final.");
        return;
      }

      await this.carregarResumo();
      await this.buscarMovimentacoes(1);
    },
    async buscarMovimentacoes(page = 1) {
      if (!this.resumo) return;
      this.carregandoMovimentacoes = true;
      try {
        const { data } = await this.$http.post("/produtos/analise/movimentacoes", {
          id_produto: this.$route.params.id_produto,
          data_inicial: this.filtros.data_inicial,
          data_final: this.filtros.data_final,
          busca: this.filtrosMovimentacao.busca || null,
          origens: this.filtrosMovimentacao.origens,
          per_page: Number(this.filtrosMovimentacao.per_page),
          page,
        });
        const resultado = data?.data || {};
        this.movimentacoes = resultado.data || [];
        this.paginacao = {
          current_page: Number(resultado.current_page || 1),
          per_page: Number(resultado.per_page || this.filtrosMovimentacao.per_page),
          total: Number(resultado.total || 0),
        };
      } catch (error) {
        this.$toast.error("Não foi possível carregar as movimentações do produto.");
      }
      this.carregandoMovimentacoes = false;
    },
    formatarNumero(valor, casas = 2) {
      return new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: casas,
        maximumFractionDigits: casas,
      }).format(Number(valor || 0));
    },
    formatarQuantidade(valor) {
      return this.formatarNumero(valor, 3);
    },
    formatarMoeda(valor) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number(valor || 0));
    },
    formatarMoedaCompacta(valor) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        notation: "compact",
        maximumFractionDigits: 1,
      }).format(Number(valor || 0));
    },
    formatarPercentual(valor) {
      return `${this.formatarNumero(valor, 2)}%`;
    },
    formatarData(valor) {
      if (!valor) return "—";
      return new Intl.DateTimeFormat("pt-BR").format(new Date(`${valor}T00:00:00`));
    },
    formatarDataHora(valor) {
      if (!valor) return "—";
      const data = typeof valor === "string" ? valor.replace(" ", "T") : valor;
      return new Intl.DateTimeFormat("pt-BR", {
        dateStyle: "short",
        timeStyle: "short",
      }).format(new Date(data));
    },
    formatarPeriodo(valor) {
      if (!valor) return "";
      const [ano, mes, dia] = valor.split("-");
      if (this.resumo?.periodo?.agrupamento === "mes") return `${mes}/${ano}`;
      return `${dia}/${mes}`;
    },
    formatarImpacto(item) {
      if (item.impacto_estoque === null) {
        return `= ${this.formatarQuantidade(item.quantidade)}`;
      }
      const sinal = Number(item.impacto_estoque) > 0 ? "+" : "";
      return `${sinal}${this.formatarQuantidade(item.impacto_estoque)}`;
    },
    classeTipo(tipo) {
      if (tipo === "entrada") return "label-light-success";
      if (tipo === "saida") return "label-light-danger";
      if (tipo === "ajuste") return "label-light-primary";
      return "label-light-secondary";
    },
    descricaoTipo(tipo) {
      if (tipo === "entrada") return "Entrada";
      if (tipo === "saida") return "Saída";
      if (tipo === "ajuste") return "Ajuste";
      return "Informativo";
    },
    classeStatusVariacao(status) {
      if (status === "disponivel") return "label-light-success";
      if (status === "negativo") return "label-light-danger";
      return "label-light-warning";
    },
    descricaoStatusVariacao(status) {
      if (status === "disponivel") return "Disponível";
      if (status === "negativo") return "Estoque negativo";
      return "Sem estoque";
    },
    classeStatusLote(status) {
      if (status === "disponivel") return "label-light-success";
      if (status === "vencido") return "label-light-danger";
      if (status === "a_vencer") return "label-light-warning";
      return "label-light-secondary";
    },
    descricaoStatusLote(status) {
      if (status === "disponivel") return "Disponível";
      if (status === "vencido") return "Vencido";
      if (status === "a_vencer") return "Vence em até 30 dias";
      return "Sem estoque";
    },
    descricaoVencimento(lote) {
      if (lote.dias_para_vencer === null) return "Sem data de validade";
      if (lote.dias_para_vencer < 0) {
        return `Vencido há ${Math.abs(lote.dias_para_vencer)} dia(s)`;
      }
      if (lote.dias_para_vencer === 0) return "Vence hoje";
      return `Vence em ${lote.dias_para_vencer} dia(s)`;
    },
  },
};
